import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import $ from 'jquery';
import { I18n } from 'react-redux-i18n-lite';
import { Input, Avatar } from '@netexknowledge/smart-components';
import * as guestActions from '../../actions/guestActions';
import { GUEST_CODE_ERROR } from '../../actions/guestActions';
import * as messageAlert from '../../actions/messageAlertAction';
import AuthWrapper from '../AuthWrapper';
import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import { smartLoaderService } from '../../services/domain/smartLoaderService';
import routerHistory from '../../routerHistory';
import { ROUTES } from '../../const';
import { getGuestProfileFromStorage } from '../../shared';
import * as analyticsApi from '../../services/api/analyticsApi';
import { ANALYTICS_EVENT, ANALYTICS_CONTEXT } from '../../types/analytics';

const getInitials = clientName => {
  if (!clientName) {
    return '';
  }
  return clientName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('');
};

const getValidDays = expiresAt => {
  if (!expiresAt) {
    return null;
  }
  const diffMs = new Date(expiresAt).getTime() - Date.now();
  if (Number.isNaN(diffMs)) {
    return null;
  }
  return Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)));
};

export class GuestLanding extends React.Component {
  constructor(props) {
    super(props);
    const codeFromRoute = (props.routeParams && props.routeParams.code) || '';
    const { name, email } = getGuestProfileFromStorage();
    this.state = {
      code: codeFromRoute.toUpperCase(),
      name,
      email
    };
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleValidateSubmit = this.handleValidateSubmit.bind(this);
    this.handleEnterSubmit = this.handleEnterSubmit.bind(this);
    this.handleTryAnotherCode = this.handleTryAnotherCode.bind(this);
  }

  static propTypes = {
    routeParams: PropTypes.object,
    guestActions: PropTypes.object,
    messageAlert: PropTypes.object,
    resolvedClient: PropTypes.object,
    codeError: PropTypes.object,
    isFetching: PropTypes.bool
  };

  componentDidMount() {
    $('#wrapperBackground').addClass('background-color-opaque-opacity');
    const { code } = this.state;
    if (code) {
      smartLoaderService.open();
      this.props.guestActions.validateGuestCode(code);
    }
  }

  componentDidUpdate(prevProps) {
    const { isFetching, codeError, messageAlert } = this.props;
    if (prevProps.isFetching && !isFetching) {
      smartLoaderService.close();
    }
    if (codeError && codeError !== prevProps.codeError) {
      if (codeError.type === GUEST_CODE_ERROR.EXPIRED) {
        messageAlert.error(I18n.t('guest.error.codeExpired'));
      } else if (codeError.type === GUEST_CODE_ERROR.GENERIC) {
        messageAlert.error(I18n.t('error.generic500'));
      }
    }
  }

  handleCodeChange(event) {
    this.setState({ code: event.target.value.toUpperCase().replace(/\s/g, '') });
  }

  handleNameChange(event) {
    this.setState({ name: event.target.value });
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
    const { codeError } = this.props;
    if (codeError && codeError.type === GUEST_CODE_ERROR.INVALID_DATA) {
      this.props.guestActions.clearGuestCodeError();
    }
  }

  handleValidateSubmit(e) {
    e.preventDefault();
    const { code } = this.state;
    if (code) {
      smartLoaderService.open();
      this.props.guestActions.validateGuestCode(code);
    }
  }

  handleEnterSubmit(e) {
    e.preventDefault();
    const { code, name, email } = this.state;
    const { resolvedClient } = this.props;
    const startedAt = Date.now();
    smartLoaderService.open();
    this.props.guestActions.createGuestSession(code, name, email).then(data => {
      smartLoaderService.close();
      const isSuccess = Boolean(data && data.token);
      analyticsApi.trackAnalyticsEvent({
        event: ANALYTICS_EVENT.GUEST_ENTER,
        context: ANALYTICS_CONTEXT.GUEST_ENTER_BUTTON,
        code,
        clientId: resolvedClient.clientId,
        schoolId: resolvedClient.schoolId,
        clientName: resolvedClient.clientName,
        name,
        email,
        status: isSuccess ? 'success' : 'error',
        durationMs: Date.now() - startedAt
      });
      if (isSuccess) {
        routerHistory.push(ROUTES.GUEST_CATALOG);
      }
    });
  }

  handleTryAnotherCode() {
    this.setState({ code: '' });
    this.props.guestActions.clearGuestCodeError();
  }

  renderCodeStep(isInvalid) {
    const { code } = this.state;
    return (
      <form onSubmit={this.handleValidateSubmit} className="guest-code-row">
        <div className="guest-code-input-wrapper">
          <Input
            id="guestCode"
            type="text"
            value={code}
            onChange={this.handleCodeChange}
            placeholder={I18n.t('guest.landing.codePlaceholder')}
            state={isInvalid ? 'error' : ''}
            helper={isInvalid ? I18n.t('guest.error.codeNotFound') : ''}
          />
        </div>
        <CustomButton
          id="guestValidateButton"
          className="button guest-code-button"
          value={I18n.t('guest.login.button')}
          manuallyDisabled={!code.length}
        />
      </form>
    );
  }

  renderExpiredActions() {
    return (
      <div className="guest-expired-actions">
        <Link id="guest-request-access-link" to={ROUTES.JOIN}>
          <p className="bottom-link">{I18n.t('guest.error.requestAccess')}</p>
        </Link>
        <p className="bottom-link" onClick={this.handleTryAnotherCode}>
          {I18n.t('guest.error.tryAnotherCode')}
        </p>
      </div>
    );
  }

  renderResolvedClientStep() {
    const { resolvedClient, codeError } = this.props;
    const { code, name, email } = this.state;
    const validDays = getValidDays(resolvedClient.expiresAt);
    // name es obligatorio y no vacío, así que un 400 del BE en la práctica solo puede venir del email
    const isEmailInvalid = Boolean(codeError && codeError.type === GUEST_CODE_ERROR.INVALID_DATA);

    return (
      <>
        <div className="guest-client-card">
          <Avatar initials={getInitials(resolvedClient.clientName)} size={44} className="guest-client-avatar" />
          <div>
            <div className="guest-client-name">{resolvedClient.clientName}</div>
            <div className="guest-client-meta">
              {I18n.t('guest.landing.codeLabel')} <span className="mono">{code}</span>
              {validDays !== null ? ` · ${I18n.t('guest.landing.validDays', { days: validDays })}` : ''}
            </div>
          </div>
        </div>
        <div className="guest-form-title">{I18n.t('guest.landing.formSectionTitle')}</div>
        <form onSubmit={this.handleEnterSubmit}>
          <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12">
            <Input
              id="guestName"
              type="text"
              value={name}
              onChange={this.handleNameChange}
              placeholder={I18n.t('guest.landing.namePlaceholder')}
              required
            />
            <Input
              id="guestEmail"
              type="email"
              value={email}
              onChange={this.handleEmailChange}
              placeholder={I18n.t('guest.landing.emailPlaceholder')}
              state={isEmailInvalid ? 'error' : ''}
              helper={isEmailInvalid ? I18n.t('guest.error.invalidEmail') : ''}
              required
            />
            <CustomButton
              id="guestEnterButton"
              className="button secondary expanded guest-enter-button"
              value={I18n.t('guest.landing.enterButton')}
              manuallyDisabled={!name.trim().length || !email.trim().length}
            />
          </div>
        </form>
      </>
    );
  }

  render() {
    const { resolvedClient, codeError } = this.props;
    const isInvalid = Boolean(codeError && codeError.type === GUEST_CODE_ERROR.NOT_FOUND);
    const isExpired = Boolean(codeError && codeError.type === GUEST_CODE_ERROR.EXPIRED);
    const showResolvedClient = resolvedClient && !isInvalid && !isExpired;

    return (
      <AuthWrapper>
        <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
          <div className="row box background-color-opaque align-center" id="wrapperBackground">
            <div className="row small-12 align-top">
              <div className="column">
                <div className="column small-12 text-center guest-landing-header">
                  <Logo customCss="logo-opaque" />
                  <p className="guest-landing-subtitle">{I18n.t('guest.landing.subtitle')}</p>
                </div>
                {showResolvedClient ? this.renderResolvedClientStep() : this.renderCodeStep(isInvalid)}
                {isExpired && this.renderExpiredActions()}
              </div>
            </div>
            <div className="row align-self-bottom text-center guest-landing-footer">
              <Link id="guest-login-link" to={ROUTES.LOGINAUTH}>
                <p className="bottom-link">{I18n.t('guest.landing.hasAccount')}</p>
              </Link>
            </div>
          </div>
        </div>
      </AuthWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    resolvedClient: state.guest.resolvedClient,
    codeError: state.guest.codeError,
    isFetching: state.guest.isFetching
  };
}

function mapDispatchToProps(dispatch) {
  return {
    guestActions: bindActionCreators(guestActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestLanding);
